<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <CCardHeader class="card-header bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Pengaturan Iuran Anggota
    <template v-if="role_status && role_status.status_create">
      <CButton color="success" style="float:right" class="btn-md ml-auto" @click="tambahInvoice">Tambah</CButton>
    </template>
    </CCardHeader>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
        <li class="nav-item">
          <router-link
            to="/keanggotaan/pengaturan-iuran"
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"
            id="home-tab"
            style="background-color: #486ba7;"
            data-toggle="tab"
            href="#data-anggota"
            role="tab"
            aria-controls="data-anggota"
            aria-selected="true"
          >Pengaturan  Iuran</router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/keanggotaan/laporan-iuran"
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"            
            id="home-tab"
            data-toggle="tab"            
            href="#data-anggota"
            role="tab"
            aria-controls="data-anggota"
            aria-selected="true"
          >Laporan Iuran</router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/keanggotaan/outstanding-iuran"
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"            
            id="home-tab"
            data-toggle="tab"            
            href="#data-anggota"
            role="tab"
            aria-controls="data-anggota"
            aria-selected="true"
          >Outstanding Iuran</router-link>
        </li>
    </ul>
    <CCardBody>
      <CRow class="mb-3">
          <div class="col-sm-12 col-xl-12">          
          </div>
          <div class="col-sm-12 col-xl-12">
            <div class="form-group">
              <label for class="font-weight-bold">Pilih Periode</label>
              <multiselect
                class="mulit-select"
                label="tahun"
                placeholder="Pilih Periode"
                :show-labels="false"
                required
                v-model="periode"
                @select="changePeriode"
                :options="dataTahun"
              ></multiselect>
            </div>
          </div>
          <div class="col-sm-12 col-xl-6" style="display:none"> 
            <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Kategori Anggota</label>
              <multiselect
                class="mulit-select"
                label="namaKategori"
                placeholder="Pilih kategori anggota"
                id="kategoriSelect"
                :show-labels="false"
                required
                v-model="kategori"
                @select="selectKategori"
                :options="dataKategori"
              ></multiselect>
            </div>
          </div>
          <div class="col-sm-12 col-xl-12">
            <div class="text-right">
              <button class="btn btn-md btn-info mr-2" @click="resetFilter">Reset Filter</button>
              <button class="btn btn-md btn-success" @click="terapkan">Terapkan</button>
            </div>
          </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>        
        
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..."  v-model="searchPengaturanIuran"/>
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #nominal_iuran="{item}">
              <td class="py-2">Rp. {{ formatPrice(item.nominal_iuran) ? formatPrice(item.nominal_iuran) : '-'}}</td>
            </template>
            <template #nama_kategori="{item}">
              <td class="py-2">{{ item.nama_kategori ? item.nama_kategori : '-'  }}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_create">
                <router-link :to="'/keanggotaan/invoice/generate-invoice/'+item.id_pengaturan_iuran" class="ml-auto">
                  <CButton
                    color="warning"
                    style="float:right;"
                    class="btn-sm text-white mr-2"
                  >Buat Tagihan</CButton>
                </router-link>
                </template>
                <template v-if="role_status && role_status.status_update">
                <CButton
                  color="info"
                  square
                  size="sm"
                  class="mr-2"
                  @click="updateData(item)"
                >
                  <font-awesome-icon icon="edit" />
                </CButton>
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash"/>
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
          />
        </CCol>
      </CRow>      
    </CCardBody>

    <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true">
        <CForm v-on:submit.prevent="postData">
          <CRow >
            <div class="modal-body">
                <div class="form-group">
                  <label for="name" class="font-weight-bold">Tahun</label>
                   <multiselect
                    class="mulit-select"
                    label="tahun"
                    placeholder="Pilih Tahun"
                    :show-labels="false"
                    required
                    v-model="modelTahun"
                    @select="changePeriodeForm"
                    :options="dataTahun"
                  ></multiselect>
                </div>
                <div class="form-group">
                  <label for="name" class="font-weight-bold">Kategori Anggota</label>        
                  <multiselect
                    class="mulit-select"
                    label="namaKategori"
                    placeholder="Pilih kategori anggota"
                    id="kategoriSelect"
                    :show-labels="false"
                    required
                     @select="changeKategori"
                    v-model="modelKategori"
                    :options="dataKategori"
                  ></multiselect>
                </div>
                <div class="form-group">
                  <label for="name" class="font-weight-bold">Nominal Iuran</label>
                  <input
                    type="number"
                    class="form-control"
                    id="member"
                    min="0"
                    v-model="formData.nominalIuran"
                    placeholder="Masukkan Nominal Iuran"                      
                      />
                </div>
            </div>            
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit"  color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
  </CCard>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import PeriodeIuranService from "@/services/datamaster/periode-iuran.service";
import { AlertUtils } from '@/mixins/AlertUtils'
import { Pagination } from '@/mixins/Pagination' 
import KategoriAnggotaService from "@/services/keanggotaan/kategori-anggota.service";
import AutoNumeric from "../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";
import TextField from "@/components/formcomponent/TextField";
import PengaturanService from '@/services/datamaster/pengaturan.service'

const fields = [
  {
    key: "no",
    sorter: false,
    filter: false
  },  
  {
    key: "tahun",
    label: "Tahun",
    sorter: false,
    filter: false
  },  
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: false,
    filter: false,    
  },  
  {
    key: "nominal_iuran",
    label: "Nominal Iuran",
    sorter: false,
    filter: false
  },  

  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Pengaturan Iuran",
  mixins : [AlertUtils,Pagination],
  components: {
    VueAutonumeric,
    TextField,
  },
  data() {
    return {
      items: [],
      dataTahun : [],
      dataKategori: [],
      tahunModal : [],
      idKategoriAnggotaModal : [],
      actionPost : '',
      modelTahun: '',
      modelKategori: '',
      periode :'',
      kategori: "",
      idKategoriAnggota: '',
      title: '',
      formData : {
        idPengaturanIuran : '',
        idKategoriAnggota : '',
        nominalIuran : '',
        tahun : ''
      },
      formFilter : {
        periode : '',
        idKategoriAnggota : ''
      },
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  validations: {
    formData : {      
      idKategoriAnggota : { required },
      nominalIuran : { required },
      tahun : { required },
    },
  },

  mounted() {   
    this.roleData();
    this.getKategori();
    this.getPeriode();
    this.getData(0,10,'default')
  }, 
  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === '/keanggotaan/pengaturan-iuran' );  
        this.role_status = data;
      },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    getKategori() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          // comment console console.log(response.data.data.content);
          this.dataKategori = response.data.data.content; 
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getData(
      pageNo,
      pageSize,
      filter,
      tahun
    ) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this
      PengaturanService.getPengaturan("0", pageSize, filter, tahun)
      .then(response => {
        loader.hide()
        vm.items = response.data.data.content;
        vm.pagination.totalPages = response.data.data.totalPages;
        vm.currentPage = response.data.data.pageable.pageNumber + 1;
      }).catch(error => {
        loader.hide()
        // comment console console.log(error);
      })
    },

    getPeriode() {
      PeriodeIuranService.getPeriode(0, 100000, 'default')
      .then(response => {
        this.dataTahun = response.data.data.content
      }).catch(error => {
        // comment console console.log(error)
      })
    },

    tambahInvoice() {
      this.myModal = true
      this.actionPost = "insert";
      this.modelTahun = [],
      this.modelKategori = [],
      this.formData = {
        idPengaturanIuran : '',
        idKategoriAnggota : '',
        nominalIuran : '',
        tahun : ''
      },
      this.title = "Tambah";
    },

    updateData(item, index) {      
      this.myModal = true
      this.formData.idPengaturanIuran = item.id_pengaturan_iuran
      this.modelTahun = {
        tahun: item.tahun
      } 
      this.modelKategori = {
        namaKategori: item.nama_kategori
      }
      this.formData.tahun = item.tahun
      this.formData.idKategoriAnggota = item.id_kategori_anggota
      this.formData.nominalIuran = item.nominal_iuran
      this.actionPost = "update"
      this.title = "Edit"
     
    },

    postData() {
      this.$v.$touch();
      if (this.actionPost == "insert") {
        // if (this.$v.$invalid) {
        //   return;
        // } else {
          this.insertData(this.formData);
        // }
      // } else if (this.actionPost == "update") {
      //   if (this.$v.$invalid) {
      //     return;
        } else {
          this.putData();
        }
      // }
    },

    insertData(formData) {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      
      /**
       * Clear From Data
       */
      this.formData = {
        idPengaturanIuran : '',
        idKategoriAnggota : '',
        nominalIuran : '',
        tahun : ''
      }

      PengaturanService.postPengaturan(formData)
      .then(reponse => {
        vm.myModal = false
        loader.hide();
        
        vm.getData(
          0,
          10,
          "",
          vm.formFilter.periode,
          ""
        );
        vm.alertSuccess()
      }).catch(error  => {
        loader.hide()
        vm.alertError(error.response.data.message);
      })      
    },
    
    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);
      var vm = this;
      PengaturanService.putPengaturan(this.formData)
        .then(response => {
          vm.myModal = false;
          vm.alertEditSuccess();
          vm.getData("0", this.pageSize, this.searchPengaturanIuran, this.formFilter.periode, this.formFilter.idKategoriAnggota);
        })
        .catch(error => {
          // comment console console.log(error);
          vm.alertError(error.response.data.message);
        });
    },  

    deleteData(item, index) {
      var vm = this
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            PengaturanService.deletePengaturan(item)
            .then(response => {
                // comment console console.log(response);
                vm.alertDeleteSuccess();
                vm.getData("0", this.pageSize, this.searchPengaturanIuran, this.formFilter.periode);
            })
            .catch(error => {
              vm.alertError();
              // comment console console.log(error);
            });
          } 
        });
    },

    selectKategori(value) {
      this.formFilter.idKategoriAnggota = value.idKategoriAnggota
    },
    
    changePeriode(value) {
      this.formFilter.periode = value.tahun
    },
    
    changePeriodeForm(value) {
      this.formData.tahun = value.tahun
    },

    changeKategori(value) {
      this.formData.idKategoriAnggota = value.idKategoriAnggota
      this.formFilter.idKategoriAnggota = value.idKategoriAnggota
    },
    
    terapkan() {
      this.getData(
        "0",
        this.pageSize,
        this.searchPengaturanIuran,
        this.formFilter.periode,
        ""
      );
    },
    resetFilter() {
      this.periode = ""
      this.formFilter [
        {
          periode: ""
        }
      ]
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
